import { SquaresFour } from '@phosphor-icons/react';

export default SquaresFour;
